import {Component, EventEmitter, Input, Output,} from '@angular/core';
import {Amount} from "../../../../../../open-api-generated/models/amount";
import {InterestedEntity} from "../../../../../../open-api-generated/models/interested-entity";
import {Locality} from "../../../../../../open-api-generated/models/locality";
import {Locker} from "../../../../../../open-api-generated/models/locker";

@Component({
  selector: 'app-interested-entity-view-component',
  templateUrl: './interested-entity-view.component.html',
  styleUrls: ['./interested-entity-view.component.scss']
})
export class InterestedEntityViewComponent {
  @Input('type') type = null;
  @Input('validationErrors') validationErrors: null;
  @Input('isSender') isSender: boolean = false;
  @Input('isLockerService') isLockerService: boolean = false;
  @Input('disabled') disabled: boolean = true;
  @Input('name') name: string = null;
  @Input('interestedEntity') interestedEntity: InterestedEntity;
  @Output('onInterestedEntityChangedEvent') onInterestedEntityChangedEvent: EventEmitter<InterestedEntity> = new EventEmitter<InterestedEntity>

  privatePersonChanged(): void {
    // @ts-ignore
    this.interestedEntity.private_person = 'true' === this.interestedEntity.private_person;

    if (this.interestedEntity.private_person) {
      this.interestedEntity.contact_name = null;
    }

    this.onChangedEvent();
  }

  localityChangedEventHandler(locality: any): void {
    this.interestedEntity.address.postal_code = locality.main_postal_code;
    this.interestedEntity.address.locality = {
      id: locality.id,
      name: locality.name,
    };

    this.onChangedEvent();
  }


  addressDetailsChangedEventHandler(details: string): void {
    this.interestedEntity.address.details = details;
    this.onChangedEvent();
  }

  lockerChangedEventHandler(locker: Locker): void {
    this.interestedEntity.locker = locker;
    this.onChangedEvent();
  }

  onChangedEvent(): void {
    this.onInterestedEntityChangedEvent.emit(this.interestedEntity);
  }
}
